import { get } from 'lodash';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';

type MyState = RootState['coupon'];

const getCurrentState = (state: RootState): MyState => state['coupon'];

const selector = <T = MyState>(key: keyof T, defaultValue?: any) => useAppSelector(state => get(getCurrentState(state), key, defaultValue));

const couponReceive = () => selector('couponReceive') as MyState['couponReceive'];
const couponReceiveDiscountSetting = () => selector('couponReceiveDiscountSetting') as MyState['couponReceiveDiscountSetting'];
const birthdayDiscount = () => selector('birthdayDiscount') as MyState['birthdayDiscount'];
const customerCouponTarget = () => selector('customerCouponTarget') as MyState['customerCouponTarget'];
const couponReferralSetting = () => selector('couponReferralSetting') as MyState['couponReferralSetting'];
const payloadResendOtp = () => selector('payloadResendOtp') as MyState['payloadResendOtp'];
const refIdReceiveCoupon = () => selector('refIdReceiveCoupon') as MyState['refIdReceiveCoupon'];

const couponSelectors = {
  couponReceive,
  couponReceiveDiscountSetting,
  birthdayDiscount,
  customerCouponTarget,
  couponReferralSetting,
  payloadResendOtp,
  refIdReceiveCoupon,
};

export default couponSelectors;
